// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2BZcq","radioRow":"SimpleQuestionBuilderModal_radioRow__PDS47"};